import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CommentItem from '@/components/comments/CommentItem';
import Drip from 'drip';
export default {
  name: 'hot-comment',
  components: {
    CommentItem: CommentItem
  },
  props: {
    commentInfo: {
      type: Object,
      default: {}
    },
    showNewPage: {
      type: Boolean,
      default: false
    },
    projectId: {
      type: Number,
      default: 0
    },
    isCategory: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      hiddenPostComment: false
    };
  },
  methods: {
    postComment: function postComment() {
      var performance_id = this.$route.params.performanceId;
      var city_id = Drip.constant.cityId;
      var options = {
        performance_id: performance_id,
        city_id: city_id
      };
      this.statsHandler('postCommentInHot', options);
      this.$emit('postComment');
    },
    statsHandler: function statsHandler(type, options) {
      var self = this;
      var handlers = {
        // 热门评论曝光
        hotCommentView: function hotCommentView() {
          window.seedAction({
            bid: 'b_movie_j80bqxtc_mv',
            evt: 'view',
            custom: Object.assign({}, options, {
              custom: Object.assign({}, options)
            })
          });
        },
        // 热门评价点击打点
        commentClick: function commentClick() {
          var performance_id = options.performance_id,
            city_id = options.city_id;
          window.seedAction({
            bid: 'b_movie_bt2tuju0_mc',
            custom: {
              performance_id: performance_id,
              city_id: city_id,
              custom: {
                performance_id: performance_id,
                city_id: city_id
              }
            }
          });
        },
        // 热门评价图片曝光
        hotCommentImgView: function hotCommentImgView() {
          window.seedAction({
            bid: 'b_movie_bt2tuju0_mv',
            evt: 'view'
          });
        },
        // 热门评价图片点击
        commentImgClick: function commentImgClick() {
          window.seedAction({
            bid: 'b_movie_bt2tuju0_mc'
          });
        },
        // 查看全部评价展示
        searchAllCommentsView: function searchAllCommentsView() {
          if (self.showNewPage) {
            window.seedAction({
              evt: 'view',
              bid: 'b_movie_arwaxvlc_mv',
              cid: 'c_c21utqjf',
              abtest: 1,
              custom: {
                performance_id: self.projectId
              }
            });
          } else {
            window.seedAction({
              bid: 'b_movie_v4mnb512_mv',
              evt: 'view',
              abtest: 0
            });
          }
        },
        // 查看全部评价点击
        searchAllCommentsClick: function searchAllCommentsClick() {
          if (self.showNewPage) {
            window.seedAction({
              evt: 'click',
              bid: 'b_movie_arwaxvlc_mc',
              cid: 'c_c21utqjf',
              abtest: 1,
              custom: {
                performance_id: self.projectId
              }
            });
          } else {
            window.seedAction({
              bid: 'b_movie_v4mnb512_mc',
              abtest: 0
            });
          }
        },
        // 热评模块写评价曝光埋点
        viewCommentInHot: function viewCommentInHot() {
          var performance_id = options.performance_id,
            city_id = options.city_id;
          window.seedAction({
            bid: 'b_movie_hw3g1cae_mv',
            evt: 'view',
            custom: {
              performance_id: performance_id,
              city_id: city_id,
              custom: {
                performance_id: performance_id,
                city_id: city_id
              }
            }
          });
        },
        // 热评模块写评价埋点
        postCommentInHot: function postCommentInHot() {
          var performance_id = options.performance_id,
            city_id = options.city_id;
          window.seedAction({
            bid: 'b_movie_hw3g1cae_mc',
            custom: {
              performance_id: performance_id,
              city_id: city_id,
              custom: {
                performance_id: performance_id,
                city_id: city_id
              }
            }
          });
        }
      };
      var handler = handlers[type];
      if (handler) {
        try {
          handler(options);
        } catch (e) {
          console.error('This error is token place in Components HotComment, The error is', e);
        }
      }
    },
    seeAll: function seeAll() {
      // 查看全部评价点击打点
      this.statsHandler('searchAllCommentsClick');
      this.$emit('toComment');
    }
  },
  computed: {
    // 是否展示热评模块
    showHotComment: function showHotComment() {
      var _queryComments$commen;
      var _this$commentInfo = this.commentInfo,
        scoreStatus = _this$commentInfo.scoreStatus,
        queryComments = _this$commentInfo.queryComments;
      return scoreStatus && (queryComments === null || queryComments === void 0 ? void 0 : (_queryComments$commen = queryComments.commentList) === null || _queryComments$commen === void 0 ? void 0 : _queryComments$commen.length);
    }
  },
  created: function created() {
    if (this.showHotComment) {
      var _this$commentInfo2 = this.commentInfo,
        scoreStatus = _this$commentInfo2.scoreStatus,
        commentList = _this$commentInfo2.commentList,
        commented = _this$commentInfo2.commented,
        commentStatus = _this$commentInfo2.commentStatus;
      var isLogin = Drip.User.isLogin;
      var _Drip$UA = Drip.UA,
        IS_CMBAPP = _Drip$UA.IS_CMBAPP,
        IS_MAIDANBA = _Drip$UA.IS_MAIDANBA,
        IS_SHENZHEN_ICBC = _Drip$UA.IS_SHENZHEN_ICBC;
      var hiddenPostComment = isLogin && commented || IS_CMBAPP || IS_MAIDANBA || IS_SHENZHEN_ICBC || !commentStatus;
      this.hiddenPostComment = hiddenPostComment;
      var performance_id = this.$route.params.performanceId;
      var city_id = Drip.constant.cityId;
      var options = {
        performance_id: performance_id,
        city_id: city_id
      };
      // 查看全部按钮曝光打点
      this.statsHandler('searchAllCommentsView');
      if (scoreStatus) {
        // 热门评价模块展示打点
        this.statsHandler('hotCommentView', options);
        // 热门评价图片曝光打点
        var isExistImg = commentList.some(function (item) {
          return item.images && item.images.length;
        });
        if (isExistImg) {
          this.statsHandler('hotCommentImgView');
        }
      }
      // 发评价按钮曝光埋点
      if (!hiddenPostComment) {
        this.statsHandler('viewCommentInHot', options);
      }
    }
  },
  watch: {
    commentInfo: function commentInfo(newVal) {
      var isLogin = Drip.User.isLogin;
      var _Drip$UA2 = Drip.UA,
        IS_CMBAPP = _Drip$UA2.IS_CMBAPP,
        IS_MAIDANBA = _Drip$UA2.IS_MAIDANBA,
        IS_SHENZHEN_ICBC = _Drip$UA2.IS_SHENZHEN_ICBC;
      this.hiddenPostComment = isLogin && newVal.commented || IS_CMBAPP || IS_MAIDANBA || IS_SHENZHEN_ICBC;
    }
  }
};